/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssetsItemCustomResource } from '../models/AssetsItemCustomResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AssetsItemCustomService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Lister les assets personnalises
     * Les valeurs propres a une entreprise (`customer_id`) pour un asset (`assets_item_id`).
     * @returns AssetsItemCustomResource Array of `AssetsItemCustomResource`
     * @throws ApiError
     */
    public adminAssetsitemcustomIndex(): CancelablePromise<Array<AssetsItemCustomResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/assetsitemcustom',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Personnaliser un asset pour une entreprise
     * `assets_item_id`, `customer_id` et `content` (JSON), valide selon les regles et le type de l'asset de reference. 404 si l'asset de reference n'existe pas.
     * @param requestBody
     * @returns AssetsItemCustomResource `AssetsItemCustomResource`
     * @throws ApiError
     */
    public adminAssetsitemcustomStore(
        requestBody: {
            assets_item_id: number;
            customer_id: number;
            content: string;
        },
    ): CancelablePromise<AssetsItemCustomResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/assetsitemcustom',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Assets personnalises d'une entreprise
     * Malgre le chemin `/{customer_id}`, ce n'est pas un enregistrement mais **la liste** des assets personnalises de l'entreprise, chacun avec l'asset de reference. Tableau vide si aucun.
     * @param customerId
     * @returns AssetsItemCustomResource Array of `AssetsItemCustomResource`
     * @throws ApiError
     */
    public adminAssetsitemcustomShow(
        customerId: string,
    ): CancelablePromise<Array<AssetsItemCustomResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/assetsitemcustom/{customer_id}',
            path: {
                'customer_id': customerId,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Modifier un asset personnalise
     * Mise a jour du `content`, revalide selon l'asset de reference.
     * @param id
     * @param requestBody
     * @returns AssetsItemCustomResource `AssetsItemCustomResource`
     * @throws ApiError
     */
    public adminAssetsitemcustomUpdate(
        id: string,
        requestBody?: {
            assets_item_id?: number;
            customer_id?: number;
            content?: string;
        },
    ): CancelablePromise<AssetsItemCustomResource> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/admin/assetsitemcustom/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Supprimer un asset personnalise
     * L'entreprise retrouve la valeur par defaut de l'asset.
     * @param id
     * @returns any
     * @throws ApiError
     */
    public adminAssetsitemcustomDestroy(
        id: string,
    ): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/assetsitemcustom/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
}
